import axios from "redaxios";
import { DXP_REST_API, REST_NONCE } from "@app/config/constants";

export default axios.create({
	baseURL: DXP_REST_API,
	headers: {
		"Content-Type": "application/json",
		"X-WP-Nonce": REST_NONCE,
	},
});
